export default __webpack_public_path__ + "static/media/_DSC0518-thumb.41fb6cbf.jpg";